"use client"
import { Box, Typography, Container, Grid, Paper } from "@mui/material"
import { styled } from "@mui/material/styles"
// import { Crown, FileText, Award, Target } from "lucide-react"
import { LuCrown, LuFileText, LuAward, LuTarget } from "react-icons/lu";
import Animator from "../../../components/Aminator/Animator"
import { useIsMobile } from "../../../components/hooks/useIsMobile"
import image1 from "../../../assets/images/Img (1).png"
import image2 from "../../../assets/images/Img (2).png"
// import image3 from "../../../assets/images/Img (1).png"

// Styled components
const SectionContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(10, 2),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(12, 2),
  },
}))

const FeatureItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(2),
  gap: theme.spacing(2),
}))

const IconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 48,
  height: 48,
  borderRadius: "50%",
  border: "1px solid #E25822",
  color: "#E25822",
}))

const ImageContainer = styled(Paper)(({ theme }) => ({
  borderRadius: 12,
  overflow: "hidden",
  height: "100%",
  boxShadow: "none",
}))

function InfoBlockSection() {
  const mobile = useIsMobile()

  const features = [
    { icon: <LuCrown size={24} />, title: "Quality Job" },
    { icon: <LuFileText size={24} />, title: "Resume builder" },
    { icon: <LuAward size={24} />, title: "Top Companies" },
    { icon: <LuTarget size={24} />, title: "Top Talents" },
  ]

  return (
    <SectionContainer maxWidth="lg">
      <Grid container spacing={6} alignItems="center">
        {/* Left Column - Text Content */}
        <Grid item xs={12} md={5}>
          <Animator variant="slide" delay={300} timeout={500}>
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Monserrat, sans-serif",
                fontSize: mobile ? "2rem" : "2.5rem",
                fontWeight: 700,
                color: "#111111",
                lineHeight: 1.2,
                mb: 3,
              }}
            >
              We Work With The Best
            </Typography>
          </Animator>

          <Animator variant="fade" delay={400} timeout={500}>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Monserrat, sans-serif",
                color: "#555555",
                lineHeight: 1.7,
                fontSize: "1rem",
                mb: 5,
              }}
            >
              We rigorously screen every candidate and organization to ensure you get the best talent and opportunities.
            </Typography>
          </Animator>

          {/* Feature Items in 2x2 Grid */}
          <Grid container spacing={3}>
            {features.map((feature, index) => (
              <Grid item xs={6} key={index}>
                <Animator variant="fade" delay={500 + index * 100} timeout={500}>
                  <FeatureItem>
                    <IconWrapper>{feature.icon}</IconWrapper>
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: "1rem",
                        fontWeight: 600,
                        color: "#333333",
                      }}
                    >
                      {feature.title}
                    </Typography>
                  </FeatureItem>
                </Animator>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Right Column - Image Grid - RESTRUCTURED */}
        <Grid item xs={12} md={7}>
          <Grid container spacing={2}>
            {/* First image (woman with laptop) */}
            <Grid item xs={12} sm={6}>
              <Animator variant="fade" direction="left" delay={600} timeout={500}>
                <ImageContainer elevation={0} sx={{ height: mobile ? 300 : 500 }}>
                  <Box
                    component="img"
                    src={image1}
                    alt="Woman working on laptop"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </ImageContainer>
              </Animator>
            </Grid>

            {/* Second and third images stacked */}
            <Grid item xs={12} sm={6}>
              <Grid container direction="column" spacing={2}>
                {/* Second image (woman with tablet) */}
                <Grid item>
                  <Animator variant="fade" direction="down" delay={700} timeout={500}>
                    <ImageContainer elevation={0} sx={{ height: mobile ? 260 : 275 }}>
                      <Box
                        component="img"
                        src={image2}
                        alt="Woman with tablet"
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </ImageContainer>
                  </Animator>
                </Grid>

                {/* Third image (background texture) */}
                <Grid item>
                  <Animator variant="fade" direction="up" delay={800} timeout={500}>
                    <ImageContainer elevation={0} sx={{ height: mobile ? 180 : 225 }}>
                      <Box
                        component="img"
                        src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Img%20%282%29-h1Adu3akVqJKrmTJCW41aXlSEBC8Mk.png"
                        alt="Background texture"
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </ImageContainer>
                  </Animator>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SectionContainer>
  )
}

export default InfoBlockSection

